/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

export interface LightningBoltIconProps {
  color?: string;
  size?: IconSize;
}
/*
 * Defines the Design Language System (DLS) Lightning Bolt Icon component.
 */
export const LightningBoltIcon = ({size = IconSize.small, color}: LightningBoltIconProps) => {
  const {iconSize} = useIconDLS({size});
  const legacyColor = color || dlsColor('aaBlue');
  return (
    <ThemeIconProvider name='ShockIcon' size={size} color={color} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox="0 0 16 35" fill={'none'}>
        <path d="M10.5882 12.0001L14 1.00009L1 15.3462H5.70587L1 22.0001H5.20587L1 33.5001L15 18H10.5882L15 12.0001H10.5882Z" stroke={legacyColor} strokeWidth="2" strokeLinejoin="round"/>
      </svg>
    )} />
  );
};

export default memo(LightningBoltIcon);
